// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__tR7mX","footer_content":"footer_footer_content__4vpSw"};